/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bandage'
export default icon
